/**
 * Gilded Veil mobile gallery: keep is-active + thumb aria-current in sync
 * when customers swipe the scroll-snap media list. Scoped to gilded templates.
 */
(function () {
  function isGilded() {
    var b = document.body;
    return !!(
      b &&
      (b.classList.contains('template-product-gilded_01') ||
        b.classList.contains('template-product-gilded-veil') ||
        document.documentElement.classList.contains('template-product-gilded_01') ||
        document.documentElement.classList.contains('template-product-gilded-veil'))
    );
  }

  function isMobile() {
    return window.matchMedia('(max-width: 749px)').matches;
  }

  function closestSlide(list) {
    var items = Array.prototype.slice.call(
      list.querySelectorAll('.product__media-item')
    );
    if (!items.length) return null;
    var left = list.scrollLeft;
    var best = items[0];
    var bestDist = Infinity;
    for (var i = 0; i < items.length; i++) {
      var dist = Math.abs(items[i].offsetLeft - left);
      if (dist < bestDist) {
        bestDist = dist;
        best = items[i];
      }
    }
    return best;
  }

  function syncFromSlide(gallery, slide) {
    if (!gallery || !slide) return;
    var mediaId = slide.dataset.mediaId;
    if (!mediaId) return;

    gallery.querySelectorAll('.product__media-item').forEach(function (el) {
      el.classList.toggle('is-active', el === slide);
    });

    var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
    if (!thumbs) return;
    thumbs.querySelectorAll('[data-target]').forEach(function (item) {
      var btn = item.querySelector('button');
      if (!btn) return;
      var on = item.getAttribute('data-target') === mediaId;
      if (on) btn.setAttribute('aria-current', 'true');
      else btn.removeAttribute('aria-current');
    });

    // Do not call setActiveMedia here — it scrollTo's the list and fights swipe.
    // Thumb clicks still go through MediaGallery.setActiveMedia.
  }

  function bindGallery(gallery) {
    if (gallery.dataset.gvSwipeBound === '1') return;
    var list = gallery.querySelector('.product__media-list');
    if (!list) return;
    gallery.dataset.gvSwipeBound = '1';

    var ticking = false;
    var settleTimer = null;

    function onScroll() {
      if (!isMobile()) return;
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          var slide = closestSlide(list);
          syncFromSlide(gallery, slide);
        }, 80);
      });
    }

    list.addEventListener('scroll', onScroll, { passive: true });
  }

  function init() {
    if (!isGilded()) return;
    document.querySelectorAll('media-gallery').forEach(bindGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
